<template>
    <Multiselect
        v-bind="$attrs"
        :select-label="selectLabelComputed"
        :select-group-label="selectGroupLabelComputed"
        :selected-label="selectedLabelComputed"
        :deselect-label="deselectLabelComputed"
        :deselect-group-label="deselectGroupLabelComputed"
        :placeholder="placeholderComputed"
        :tag-placeholder="tagPlaceholderComputed"
    >
        <template v-for="(_, name) in $slots" #[name]="slotProps" :key="name">
            <slot :name="name" v-bind="slotProps"></slot>
        </template>

        <!-- vue-multiselect hardcodes these messages in its template, so slots are the only way to
             translate them. Skipped when a caller supplies its own, which is forwarded above. -->
        <template v-if="!$slots.maxElements" #maxElements>{{ maxElementsComputed }}</template>
        <template v-if="!$slots.noOptions" #noOptions>{{ noOptionsComputed }}</template>
        <template v-if="!$slots.noResult" #noResult>{{ noResultComputed }}</template>
    </Multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: 'VMultiselect',
    compatConfig: { MODE: 3 },
    components: { Multiselect },
    inheritAttrs: false,
    props: {
        selectLabel: String,
        selectGroupLabel: String,
        selectedLabel: String,
        deselectLabel: String,
        deselectGroupLabel: String,
        placeholder: String,
        tagPlaceholder: String,
        maxElements: String,
        noOptions: String,
        noResult: String,
    },
    computed: {
        selectLabelComputed() {
            return this.selectLabel !== undefined ? this.selectLabel : this.trans('generic.multiselect-select')
        },
        selectGroupLabelComputed() {
            return this.selectGroupLabel !== undefined ? this.selectGroupLabel : this.trans('generic.multiselect-selectGroup')
        },
        selectedLabelComputed() {
            return this.selectedLabel !== undefined ? this.selectedLabel : this.trans('generic.multiselect-selected')
        },
        deselectLabelComputed() {
            return this.deselectLabel !== undefined ? this.deselectLabel : this.trans('generic.multiselect-deselect')
        },
        deselectGroupLabelComputed() {
            return this.deselectGroupLabel !== undefined ? this.deselectGroupLabel : this.trans('generic.multiselect-deselectGroup')
        },
        placeholderComputed() {
            return this.placeholder !== undefined ? this.placeholder : this.trans('generic.multiselect-placeholder')
        },
        tagPlaceholderComputed() {
            return this.tagPlaceholder !== undefined ? this.tagPlaceholder : this.trans('generic.multiselect-tag-placeholder')
        },
        maxElementsComputed() {
            if (this.maxElements !== undefined) {
                return this.maxElements
            }

            return this.$attrs.max !== undefined ? this.trans('generic.multiselect-max-elements', {max: this.$attrs.max}) : ''
        },
        noOptionsComputed() {
            return this.noOptions !== undefined ? this.noOptions : this.trans('generic.multiselect-no-options')
        },
        noResultComputed() {
            return this.noResult !== undefined ? this.noResult : this.trans('generic.multiselect-no-result')
        },
    },
}
</script>
